<template>
    <v-card class="study fill-height">
        <v-card-title primary-title>
            <v-icon @click="back" class="icon-back">
                keyboard_arrow_left
            </v-icon>
            <div>
                <div class="headline">{{ selectedPoll.name }}</div>
                <div><b>Questionnaire :</b> {{ selectedPoll.score.name }}</div>
            </div>
            <!--<v-spacer></v-spacer>-->
            <v-spacer></v-spacer>

            <td class="text-xs-right">
                <v-btn right color="primary" @click="exportPoll">
                    Export
                </v-btn>
            </td>
        </v-card-title>

        <v-divider></v-divider>

        <router-view></router-view>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {getTranslationString} from "../../helper";

export default {
    components: {},
    computed: {
        ...mapState(
            'polls',
            {
                selectedPoll: state => state.selectedPoll
            }
        ),
    },
    data() {
        return {
            deleteDialog: false,
        }
    },
    created() {
        this.setSelectedPollId(this.$route.params.id)
        this.getPollInfo()
    },
    methods: {
        back() {
            this.$router.back()
        },
        ...mapActions('polls', [
            'getPollInfo',
            'getPollExport'
        ]),
        ...mapMutations('polls', [
            'setSelectedPollId'
        ]),
        getText(key) {
            return getTranslationString(key)
        },
        exportPoll() {
            this.getPollExport(this.selectedPoll.id).then(response => {
                let fileName = response.headers["content-disposition"].split("filename=")[1];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                        fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                    document.body.appendChild(link);
                    link.click();
                }
            }).catch(reason => {
                //Stay here..
            })
        }
    }
}
</script>

